module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Like-34f38cad202913348cc4a6ecb3fa39bb40aca555dbbf19eb59d748fcf1f2cf81.svg";